import { render, staticRenderFns } from "./EnableDisableAudios.vue?vue&type=template&id=bc539076&scoped=true"
import script from "./EnableDisableAudios.vue?vue&type=script&lang=js"
export * from "./EnableDisableAudios.vue?vue&type=script&lang=js"
import style0 from "./EnableDisableAudios.vue?vue&type=style&index=0&id=bc539076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc539076",
  null
  
)

export default component.exports